import { ChevronRight, Home } from "lucide-react";
import { useLocation } from "wouter";

interface BreadcrumbItem {
  label: string;
  href: string;
  current?: boolean;
}

interface BreadcrumbNavigationProps {
  items: BreadcrumbItem[];
}

export default function BreadcrumbNavigation({ items }: BreadcrumbNavigationProps) {
  const [, setLocation] = useLocation();

  const handleNavigate = (href: string, current?: boolean) => {
    if (!current && href !== "#") {
      setLocation(href);
    }
  };

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground">
      <button
        onClick={() => handleNavigate("/")}
        className="flex items-center hover:text-foreground transition-colors"
      >
        <Home className="w-4 h-4" />
      </button>

      {items.map((item, index) => (
        <div key={index} className="flex items-center space-x-1">
          <ChevronRight className="w-4 h-4" />
          <button
            onClick={() => handleNavigate(item.href, item.current)}
            className={`hover:text-foreground transition-colors ${
              item.current
                ? "text-foreground font-medium cursor-default"
                : "text-muted-foreground"
            }`}
            disabled={item.current}
          >
            {item.label}
          </button>
        </div>
      ))}
    </nav>
  );
}